<template>
  <div :class="{ 'h-full w-full object-cover': containerSize }">
    <RichVideo
      v-if="youtubeVideoId"
      :id="youtubeVideoId"
      :container-size="containerSize"
      :autoplay="autoplay"
    />

    <video
      v-else-if="src"
      ref="video"
      v-lazy-load
      playsinline
      :muted="videoMuted"
      :loop="loop"
      :controls="controls"
      :autoplay="autoplay"
      :class="[videoClass, { 'h-full w-full object-cover': containerSize }]"
    >
      <source :data-src="getAssetUrl(src, {}, true)" />
    </video>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { useMediaAsset } from '~/composables';

interface Props {
  src?: string;
  id?: string;
  play?: boolean;
  autoplay?: boolean;
  controls?: boolean;
  muted?: boolean;
  loop?: boolean;
  containerSize?: boolean;
  videoClass?: string;
}
const props = withDefaults(defineProps<Props>(), {
  src: '',
  id: '',
  play: false,
  autoplay: false,
  controls: false,
  muted: true,
  loop: true,
  containerSize: false,
  videoClass: '',
});

const { getAssetUrl } = useMediaAsset();

const video = ref();

function getYoutubeId(url = '') {
  if (url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|\?v=)([^#&?]*).*/;

    const match = url.match(regExp);
    if (match && match[2]) return match[2];
  }
  return false;
}

const youtubeVideoId = computed(() => props.id || getYoutubeId(props.src));

const videoMuted = computed<any>({
  get() {
    return props.muted ? 'muted' : null;
  },
  set(value) {
    if (video.value) video.value.setAttribute('muted', value ? 'muted' : null);
  },
});

const start = () => {
  videoMuted.value = props.muted;
  video.value?.play();
};
const stop = () => {
  video.value?.pause();
};

watch(
  () => props.play,
  (doPLay) => {
    doPLay ? start() : stop();
  },
);

onMounted(() => {
  videoMuted.value = props.muted;
});
</script>
